import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  useClearAllInteractionsFilters,
  useResetEphemeralInteractionsFiltersState,
} from 'src/views/Interactions/state/filters';
import { useQueryParams } from '@/common/hooks/useQueryParams';

export function useInitializeInteractionsFilters(stateKey: string) {
  const router = useRouter();
  const { clearFilters: clearFiltersParam } = router.query;
  const [initialized, setInitialized] = useState(false);
  const clearAllFilters = useClearAllInteractionsFilters(stateKey);
  const { removeQueryParam } = useQueryParams();

  const resetEphemeralFilters =
    useResetEphemeralInteractionsFiltersState(stateKey);

  // Reset search/paging when first landing on the interactions page
  // If clearFilters=true is present, clear all filters including persisted ones
  useEffect(() => {
    if (clearFiltersParam === 'true') {
      clearAllFilters();
      void removeQueryParam('clearFilters');
    } else {
      resetEphemeralFilters();
    }

    setInitialized(true);
  }, []);

  return initialized;
}
